import { Attrs, MinzeElement } from 'minze'

export interface LvcShareXIcon {}

export class LvcShareXIcon extends MinzeElement {
  attrs: Attrs = [
    ['width', '32'],
    ['height', '32'],
  ]

  html = () => `
    <svg part="icon" width="${this.width}" height="${this.height}" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M18.9833 13.5706L30.6578 0H27.8913L17.7543 11.7832L9.658 0H0.319824L12.5631 17.8183L0.319824 32.0491H3.08646L13.7913 19.6057L22.3417 32.0491H31.6798L18.9826 13.5706H18.9833ZM15.194 17.9752L13.9535 16.2009L4.08331 2.08268H8.3327L16.2981 13.4766L17.5386 15.2509L27.8926 30.0612H23.6432L15.194 17.9759V17.9752Z" fill="#1C0080"/>
    </svg>
  `

  css = () => `
    
  `
}
